/**
 * Backend releases cancelled printer unit codes as `{original}~c{wipId}`
 * (e.g. `9603/5~c13285`) so the clean code can be reused under UNIQUE.
 * Display layer should never show the technical suffix to end users.
 */

/** Matches inventory-records `buildReleasedUnitCode` suffix (`~c` + wip id). */
const RELEASED_UNIT_CODE_SUFFIX = /~c\d+$/i;

export function stripReleasedUnitCodeSuffix(code: string): string {
  return code.replace(RELEASED_UNIT_CODE_SUFFIX, '').trim();
}

export function isReleasedUnitCode(code: string | null | undefined): boolean {
  if (code == null) return false;
  return RELEASED_UNIT_CODE_SUFFIX.test(code.trim());
}

/**
 * Human-readable unique code for UI / detail print.
 * `9603/5~c13285` → `9603/5 (cancelado)`
 * Also appends ` (cancelado)` when WIP status is CANCELLED even without suffix.
 * Does not alter values used for barcodes, scanners, or label print payloads.
 */
export function formatProductCodeUniqueForDisplay(
  code: string | null | undefined,
  options?: { status?: string | null },
): string {
  if (code == null) return '—';
  const trimmed = code.trim();
  if (trimmed === '') return '—';

  const releasedBySuffix = isReleasedUnitCode(trimmed);
  const status = (options?.status ?? '').trim().toUpperCase();
  const cancelledByStatus = status === 'CANCELLED';

  if (!releasedBySuffix && !cancelledByStatus) {
    return trimmed;
  }

  const base = releasedBySuffix ? stripReleasedUnitCodeSuffix(trimmed) : trimmed;
  const displayBase = base !== '' ? base : trimmed;
  return `${displayBase} (cancelado)`;
}
